import { combineReducers } from 'redux';
import actionsReducer, { ActionsState } from './actions';
import binomeListsReducer, { BinomeListsState } from './binomeLists';
import documentationFileListsReducer, {
  DocumentationFileListsState,
} from './documentationFileLists';
import menteeListsReducer, { MenteeListsState } from './menteeLists';
import mentorListsReducer, { MentorListsState } from './mentorLists';

export type AdminStoreState = {
  menteeLists: MenteeListsState;
  mentorLists: MentorListsState;
  binomeLists: BinomeListsState;
  actions: ActionsState;
  documentationFileLists: DocumentationFileListsState;
};

const adminReducer = combineReducers({
  menteeLists: menteeListsReducer,
  mentorLists: mentorListsReducer,
  binomeLists: binomeListsReducer,
  actions: actionsReducer,
  documentationFileLists: documentationFileListsReducer,
});

export default adminReducer;